import { render, staticRenderFns } from "./dialogMotivoSolicitud.vue?vue&type=template&id=0bfb7a31"
import script from "./dialogMotivoSolicitud.vue?vue&type=script&lang=js"
export * from "./dialogMotivoSolicitud.vue?vue&type=script&lang=js"
import style0 from "./dialogMotivoSolicitud.vue?vue&type=style&index=0&id=0bfb7a31&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports